// Constants
import { MAX_ERROR_ATTEMPTS } from '../constants/iframe.handlers.constants';
// Types
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
import { IframeIdsEnumeration } from '../../enumerations/iframe-ids.enumeration';
import { IframeBuilderHandlersType } from '../types/iframe.handlers.type';

const getIframeLoadErrorById = (id: string): AppErrorEnumeration =>
  ({
    [IframeIdsEnumeration.ACCOUNT_CHECK]: AppErrorEnumeration.ACCOUNT_CHECK_IFRAME_LOAD_ERROR,
    [IframeIdsEnumeration.OPENBANKING]: AppErrorEnumeration.OPENBANKING_IFRAME_LOAD_ERROR,
    [IframeIdsEnumeration.TGSS]: AppErrorEnumeration.TGSS_IFRAME_LOAD_ERROR,
    [IframeIdsEnumeration.UPLOAD_ID]: AppErrorEnumeration.UPLOAD_ID_IFRAME_LOAD_ERROR,
    [IframeIdsEnumeration.VIDEOSELFIE]: AppErrorEnumeration.VIDEOCALL_IFRAME_LOAD_ERROR,
  }[id] || (id as AppErrorEnumeration));

const getIframeResolverErrorById = (id: string): AppErrorEnumeration =>
  ({
    [IframeIdsEnumeration.ACCOUNT_CHECK]: AppErrorEnumeration.ACCOUNT_CHECK_IFRAME_FETCH_URL_ERROR,
    [IframeIdsEnumeration.OPENBANKING]: AppErrorEnumeration.OPENBANKING_IFRAME_FETCH_URL_ERROR,
    [IframeIdsEnumeration.TGSS]: AppErrorEnumeration.TGSS_IFRAME_FETCH_URL_ERROR,
    [IframeIdsEnumeration.UPLOAD_ID]: AppErrorEnumeration.UPLOAD_ID_IFRAME_FETCH_URL_ERROR,
    [IframeIdsEnumeration.VIDEOSELFIE]: AppErrorEnumeration.VIDEOCALL_IFRAME_FETCH_URL_ERROR,
  }[id] || (id as AppErrorEnumeration));

const getIframeTimeoutErrorById = (id: string): AppErrorEnumeration =>
  ({
    [IframeIdsEnumeration.TGSS]: AppErrorEnumeration.WS_TGSS_TIMEOUT,
    [IframeIdsEnumeration.UPLOAD_ID]: AppErrorEnumeration.WS_VERIDAS_TIMEOUT,
    [IframeIdsEnumeration.VIDEOSELFIE]: AppErrorEnumeration.WS_VIDEOCALL_TIMEOUT,
  }[id] || (id as AppErrorEnumeration));

const maxAttemptsOnIframeAchieved = (attempts: number): boolean => attempts > MAX_ERROR_ATTEMPTS;

const iframeIsReadyToBeShown = ({
  frameLoaded,
  webSocketConnected,
}: Pick<IframeBuilderHandlersType, 'frameLoaded' | 'webSocketConnected'>): boolean =>
  Boolean(frameLoaded && webSocketConnected);

export {
  iframeIsReadyToBeShown,
  getIframeLoadErrorById,
  getIframeResolverErrorById,
  getIframeTimeoutErrorById,
  maxAttemptsOnIframeAchieved,
};
